'use client';
import { Box } from '@skin-seoul/design-system';
import type { HTMLMotionProps } from 'motion/react';
import { motion } from 'motion/react';
import { ANIMATION_DURATION, DELAY_DURATION } from '../constants/animation';

const MotionBox = motion.create(Box);

type SliderSectionProps = HTMLMotionProps<'div'> & {
  side: 'left' | 'right';
  expandedSection: 'left' | 'right' | null;
  previousExpandedSection?: 'left' | 'right' | null;
  children: React.ReactNode;
};

const SliderSection = ({ side, expandedSection, previousExpandedSection, children, ...rest }: SliderSectionProps) => {
  const shouldDelayExpansion = side === 'right' && previousExpandedSection === 'left' && expandedSection === 'right';
  const isLeftSection = side === 'left';

  const sectionStyle = isLeftSection
    ? {
        clipPath:
          expandedSection === 'left'
            ? 'inset(0 0 0 0)'
            : expandedSection === 'right'
              ? 'inset(0 100% 0 0)'
              : 'inset(0 50% 0 0)',
      }
    : {};

  const motionProps = isLeftSection
    ? {
        animate: sectionStyle,
        initial: { clipPath: 'inset(0 50% 0 0)' },
      }
    : {};

  return (
    <MotionBox
      position={side === 'left' ? 'absolute' : 'relative'}
      top={0}
      left={0}
      width="100%"
      height="100%"
      transition={{
        duration: ANIMATION_DURATION,
        ease: 'easeInOut',
        delay: shouldDelayExpansion ? DELAY_DURATION : 0,
      }}
      {...motionProps}
      {...rest}
    >
      <MotionBox style={{ flex: 1 }}>{children}</MotionBox>
    </MotionBox>
  );
};

export default SliderSection;
